import { Box, Typography } from '@mui/material'
import { Subscription } from '../../../models/Subscription'

interface PlanDetailsProps {
  plan: Subscription
}

export default function PlanDetails({ plan }: PlanDetailsProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: '13.29px',
          lineHeight: '100%',
          letterSpacing: '0%',
          verticalAlign: 'middle',
          color: '#06004A',
        }}
      >
        Plan Details
      </Typography>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Box
          sx={{
            width: '225px',
            display: 'flex',
            gap: 1,
            flexDirection: 'column',
            background:
              'linear-gradient(0deg, #E5F0FF, #E5F0FF),linear-gradient(180deg, #FFFFFF -9.33%, #C8DFFF 44.26%);',
            angle: '-180 deg',
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            padding: '10px',
            borderRight: '1px solid #D6D6D6',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '10.59px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            Plan Type
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 600,
              gap: 1,
              fontSize: '32px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#1705E5',
            }}
          >
            {plan.plan_name}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '10.59px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            <svg
              width='11'
              height='10'
              viewBox='0 0 11 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.80097 1L3.83981 3.60107L5.5 9M5.5 9L7.20388 3.55544L6.28641 1M5.5 9L1 3.6467M5.5 9L10 3.6467M1 3.6467L2.92233 1H8.12136L10 3.6467M1 3.6467H10'
                stroke='#04002E'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Switch Tier
          </Typography>
        </Box>
        <Box
          sx={{
            width: '225px',
            display: 'flex',
            gap: 1,
            flexDirection: 'column',
            background:
              'linear-gradient(0deg, #E5F0FF, #E5F0FF),linear-gradient(180deg, #FFFFFF -9.33%, #C8DFFF 44.26%);',
            angle: '-180 deg',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            padding: '10px',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '10.59px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            Plan Billing
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 600,
              fontSize: '32px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#1705E5',
            }}
          >
            {plan.plan_billing || '-'}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '10.59px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            <svg
              width='12'
              height='11'
              viewBox='0 0 12 11'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M6.20122 1.87394C5.99121 1.5452 5.83616 1.34975 5.64197 1.22918C5.39659 1.07682 5.10928 1.00606 4.8212 1.02703C4.49371 1.05087 4.16598 1.24906 3.51052 1.64545L2.57424 2.21167C1.91879 2.60806 1.59106 2.80626 1.41785 3.08522C1.26549 3.3306 1.19472 3.61791 1.2157 3.90599C1.23954 4.23348 1.43773 4.56121 1.83412 5.21666L3.81588 8.49365C4.21227 9.1491 4.41047 9.47683 4.68943 9.65004C4.79053 9.71282 4.89876 9.76174 5.01122 9.79611L4.90912 4.76941C4.9019 4.4147 4.89539 4.09551 4.9117 3.8295C4.92916 3.54463 4.97561 3.24138 5.12051 2.94212C5.33031 2.50885 5.67188 2.15312 6.09627 1.92591C6.13115 1.90723 6.16615 1.88995 6.20122 1.87394Z'
                fill='#04002E'
              />
              <path
                d='M6.04449 4.72717C6.04449 3.96118 6.04449 3.57818 6.19357 3.28561C6.3247 3.02825 6.53393 2.81902 6.79128 2.68789C7.08386 2.53882 7.46685 2.53882 8.23285 2.53882H9.32703C10.093 2.53882 10.476 2.53882 10.7686 2.68789C11.0259 2.81902 11.2352 3.02825 11.3663 3.28561C11.5154 3.57818 11.5154 3.96118 11.5154 4.72717V8.55679C11.5154 9.32279 11.5154 9.70578 11.3663 9.99836C11.2352 10.2557 11.0259 10.4649 10.7686 10.5961C10.476 10.7451 10.093 10.7451 9.32703 10.7451H8.23285C7.46685 10.7451 7.08386 10.7451 6.79128 10.5961C6.53393 10.4649 6.3247 10.2557 6.19357 9.99836C6.04449 9.70578 6.04449 9.32279 6.04449 8.55679V4.72717Z'
                fill='#04002E'
              />
            </svg>
            Switch To Annual
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
